"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjectValue = getObjectValue;
exports.setObjectValue = setObjectValue;
const platform_1 = require("@hcengineering/platform");
const clone_1 = require("./clone");
const component_1 = __importDefault(require("./component"));
/**
 * @public
 */
function getObjectValue(key, doc) {
    // Check dot notation
    if (key.length === 0) {
        return doc;
    }
    key = key.split('\\$').join('$');
    const dots = key.split('.');
    // Replace escapting, since memdb is not escape keys
    // We have dots, so iterate in depth
    let pos = 0;
    let value = doc;
    for (const d of dots) {
        if (Array.isArray(value) && isNestedArrayQuery(value, d)) {
            // Array and d is not an indexed field.
            // So return array of nested values.
            return getNestedArrayValue(value, dots.slice(pos).join('.'));
        }
        value = value?.[d];
        pos++;
    }
    return value;
}
/**
 * @public
 */
function setObjectValue(key, doc, newValue) {
    // Check dot notation
    if (key.length === 0) {
        return;
    }
    key = key.split('\\$').join('$');
    let dots = key.split('.');
    // Replace escapting, since memdb is not escape keys
    const last = dots[dots.length - 1];
    dots = dots.slice(0, -1);
    // We have dots, so iterate in depth
    let value = doc;
    for (const d of dots) {
        if (Array.isArray(value) && isNestedArrayQuery(value, d)) {
            // Arrays are not supported
            throw new platform_1.PlatformError(new platform_1.Status(platform_1.Severity.ERROR, component_1.default.status.ObjectNotFound, { _id: 'dots' }));
        }
        const lvalue = value?.[d];
        if (lvalue === undefined) {
            value[d] = {};
            value = value?.[d];
        }
        else {
            value = lvalue;
        }
    }
    value[last] = (0, clone_1.clone)(newValue);
    return value;
}
function isNestedArrayQuery(value, d) {
    return Number.isNaN(Number.parseInt(d)) && value?.[d] === undefined;
}
function getNestedArrayValue(value, name) {
    const result = [];
    for (const v of value) {
        result.push(...arrayOrValue(getObjectValue(name, v)));
    }
    return result;
}
function arrayOrValue(vv) {
    return Array.isArray(vv) ? vv : [vv];
}
//# sourceMappingURL=objvalue.js.map